import { configureStore, combineReducers } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { watcherSaga } from "./sagas/rootSaga";
import userReducer from "./ducks/userSlice";
import showMenuReducer from "./ducks/showMenu";
import modeReducer from "./ducks/modeSlice";
import productReducer from "./ducks/productSlice";
import categoryReducer from "./ducks/categorySlice";
import attributesReducer from "./ducks/attributesSlice";
import cartReducer from "./ducks/cartSlice";
import compareReducer from "./ducks/compareSlice";
import wishListReducer from "./ducks/whishListSlice";
import saveLaterReducer from "./ducks/saveLaterSlice";
import menuReducer from "./ducks/menuSlice";
import settingsReducer from "./ducks/settingsSlice";
import customerReducer from "./ducks/customerSlice";
import accountReducer from "./ducks/accountSlice";
import CSPDashboardSlice from "./ducks/CSPDashboardSlice";
import manageInternal from "./ducks/manageInternal";
import subscriptionReducer from "./ducks/subscriptionSlice";

const sagaMiddleware = createSagaMiddleware();

const reducer = combineReducers({
	user: userReducer,
	subscription: subscriptionReducer,
	showMenu: showMenuReducer,
	mode: modeReducer,
	products: productReducer,
	category: categoryReducer,
	attributes: attributesReducer,
	cart: cartReducer,
	compare: compareReducer,
	wishList: wishListReducer,
	saveLater: saveLaterReducer,
	menu: menuReducer,
	settings: settingsReducer,
	customer: customerReducer,
	account: accountReducer,
	CSPDashboard: CSPDashboardSlice,
	manageInternal: manageInternal,
});
const store = configureStore({
	reducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			thunk: false,
			immutableCheck: false,
			serializableCheck: false,
		}).concat(sagaMiddleware),
	devTools: true,
});
sagaMiddleware.run(watcherSaga);

export default store;
